import styled, { css } from "styled-components";

export const InputWrapper = styled.div<{ $halfWidth?: boolean }>`
  position: relative;
  width: 100%;

  ${({ $halfWidth }) =>
    $halfWidth &&
    css`
      @media (min-width: 768px) {
        width: calc(50% - ${({ theme }) => theme.spacing.sm});
      }
    `}
`;

export const StyledInput = styled.input<{ $halfWidth?: boolean }>`
  width: 100%;
  height: 40px;
  padding: 0 ${({ theme }) => theme.spacing.sm};
  padding-right: 2.5rem;
  line-height: 1.2;
  font-size: ${({ theme }) => theme.fontSizes.sm};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.sm};

  ${({ $halfWidth }) =>
    $halfWidth &&
    css`
      @media (min-width: 768px) {
        width: calc(50% - ${({ theme }) => theme.spacing.sm});
      }
    `}
`;

export const ToggleVisibility = styled.button`
  position: absolute;
  top: 50%;
  right: ${({ theme }) => theme.spacing.sm};
  transform: translateY(-45%);
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.2rem;
`;
